<template>
    <div id="user_page" class="set_up" v-if="page_loaded" :key="profile.id">
        <section class="hero"></section>

        <div class="centered_md">
          <div id="step" class="form" v-if="step == 1">
            <h3>הגדרת פרופיל</h3>
            <p>ברוך הבא לעולם התוכן האיכותי והמשפחתי של TOV!<br>
אנחנו ב-TOV עובדים כל העת כדי להביא אליכם תכנים נקיים, מותאמים וברמה גבוהה. <br>
עם זאת העדפות הסינון משתנות מאדם לאדם, לכן אנו ממליצים לך להגדיר בעצמך את התוכן שבו תרצה לצפות. <br>
תוכל לבחור אם תרצה לקבל התראות במהלך הצפייה, לדלג מראש על קטעים מהם תעדיף להימנע, או פשוט לחסום מראש תכנים שאינם מתאימים לך.<br>
הכל TOV, הכל בידיים שלך, הכל ניתן לשינוי.<br>
בואו נתחיל!
            </p>
             <input type="submit" value="המשך" class="btn" @click="step = 2 "><br>
          </div>
        
          <div id="step" class="form" v-if="step == 2">
            <h3>הגדרת פרופיל</h3>
            <div class="one_box">
              <p> האם אתה מעונין לקבל התראות לפני רגעים בעיתיים בסרטים</p>
              <md-radio v-model="show_alert" :value=true >כן</md-radio> 
              <md-radio v-model="show_alert" :value=false>לא</md-radio>
          </div>
            <div class="one_box">
            <p>  האם תעדיף שהמערכת שלנו תדלג באופן אוטומטי על תכנים העלולים להיות בעייתיים?</p>
                   <md-radio v-model="show_skip" :value=true >כן</md-radio> 
                   <md-radio v-model="show_skip" :value=false>לא</md-radio>
          </div>
            <div class="one_box">
               <p>  האם תרצה לתת למשתמש הרשאות לערוך את הפרופיל?</p>
                    <md-radio v-model="has_perms" :value=true >כן</md-radio> 
                   <md-radio v-model="has_perms" :value=false>לא</md-radio>
          </div>
                 <input type="submit" value="המשך" class="btn" @click="step = 3 "><br>
          </div>
      
         <div id="step" class="form" v-if="step == 3">
            <h3>הגדרת פרופיל</h3>
          <p>  שם משתמש וסיסמה:</p>
          <input type="text" class="" placeholder="שם" v-model="profile.name" style="margin-left:20px"> 
         <input type="password" placeholder="הקלד סיסמה" v-model="profile.password" style=""  name="password">
         <input type="submit" value="המשך" class="btn" @click=" step = 4" style="margin-top:30px">
         <label>*נתונים אלו ישמשו אתכם בכל כניסה דרך פרופיל זה, מומלץ לבחור סיסמה שיהיה לכם קל לזכור</label>
        </div>
       
        <div id="step" v-if="step == 4" class="form">
          <form name="signupFRM" id="join_content" autocomplete="off" @submit.prevent="save()">
            <p>באפשרותך לנהל את רמת סינון התוכן שאותה תצרוך על ידי בחירת רמת ההגנה והסינון. איזו רמת סינון תתאים לך?</p>
            <ul class="inputs_group">
              <li>
                <ul class="frmUL"><li class=""><label class="caption"></label><span class="field">
                      <div id="restrictions_input">
                  <label v-for="restrictions_item in restrictions_list" :key="restrictions_item.id" @click="plan_id = restrictions_item.id" :class="(plan_id == restrictions_item.id ? 'active' : '')" >
                   <i :class="restrictions_item.icon_url "></i>
                    <span v-text="restrictions_item.name"></span>
                    <p v-text="restrictions_item.details"></p>
                  </label>
                      </div>
                      </span>
                      </li></ul>
                <div class="hr"></div>
              </li>
              <li>
                <div class="clr"></div>
              </li>
            </ul>
            <input type="submit" value="המשך" class="btn" @click="profile.has_perms = true"><br>

          </form>
          </div>
        </div>

    </div>
</template>

<script>

export default {
  data() {
    return {
      page_loaded: false,
      step: 1,
      id: this.$route.params.id,
      profile: false,
      restrictions: [],
      saved_restrictions: [],
      insert_mode: false,
      show_alert : true,
      has_perms:true,
      show_skip : true,
      plan_id: 3,

    };
  },
  methods: {

    save(){
    
    this.api_call({ url: 'save_profile', data: {
      insert_mode: true, 
      id: this.id, 
      name: this.profile.name, 
      age: this.profile.age, 
      plan_id: this.plan_id,
      limit_hours: this.profile.limit_hours, 
      password: this.profile.password,
      perms_show_alerts: this.show_alert ,
      perms_auto_skip: this.show_skip,
      perms_block_items: (this.profile.perms_block_items ? 1 : 0),
      has_perms: this.has_perms,
      new_setup: (this.profile.new_setup ? 0 : 1),
    }, onComplete: function(){


      document.location = '/';

    } } );

    },

    remove_profile(){
      if (!confirm('אנא אשר את מחיקת הפרופיל')) return false;
      this.api_call({ url: 'remove_profile', data: { id: this.id }, onComplete: function(){
        document.location = '/user/profiles';

      } } );
    }
  },
  computed: {
    // a computed getter
    restrictions_list: function () {
    
        var restrictions = JSON.parse(JSON.stringify(this.$store.state.restrictions_plans));
      
        for (let i in restrictions)
        {
            restrictions[i].is_active = (this.saved_restrictions.indexOf(restrictions[i].id) !== -1);
        }

        return restrictions;
      
    }
  },
  mounted() {

var self = this;


    if (this.id > 0)
    {
      // categories
      this.api_call({ url: 'get_profile', data: { id: this.id }, onComplete: function(data){
        
        data.data.data.perms_show_alerts = (data.data.data.perms_show_alerts == 1);
        data.data.data.perms_auto_skip = (data.data.data.perms_auto_skip == 1);
        data.data.data.perms_block_items = (data.data.data.perms_block_items == 1);

        self.profile = data.data.data;
        self.page_loaded = true;

        
        self.saved_restrictions = data.data.data.restrictions;

      } } );
    }
    else
    {
      this.insert_mode = true;
      this.page_loaded = true;
      this.profile = {
        name: '',
        age: '',
        restrictions: [],
        limit_hours: '', 
        password: ''

      };

    }
  }
}
</script>      
<style scoped>
h3{    color: #dd1a7b;
    font-size: 35px;
    font-weight: 700;
    margin-bottom: 15px;}
.btn{margin: 0 10px;}
p{margin-bottom: 35px !important;}
</style>  